import CCActionTypes from '../action-types/cc-mode';
export const addNotification = (notification) => ({
    type: CCActionTypes.ADD_NOTIFICATION,
    payload: notification,
});
export const clearNotifications = () => ({
    type: CCActionTypes.CLEAR_NOTIFICATIONS,
});
export const deleteNotification = (index) => ({
    type: CCActionTypes.DELETE_NOTIFICATION,
    payload: index,
});
// For the desktop app, when the conversation ends, we stay in this CC mode
// window. In order to handle resizing the window, there are 3 different modes
// to know which state the app is in.
export const setCCMode = (ccMode) => ({
    type: CCActionTypes.SET_MODE,
    payload: ccMode,
});
// Used to know whether to display the participants and conversation buttons.
export const setShowBubbleAboveCCMode = (shouldShow) => ({
    type: CCActionTypes.SET_SHOW_BUBBLE_ABOVE_CC_MODE,
    payload: shouldShow,
});
